/**
 * danismanSatislariHelpers.js
 *
 * `components/crm/DanismanSatislariPanels.jsx` içindeki satır sınıflandırma
 * mantığı — bilinçli olarak SAF FONKSİYON olarak buraya (bağımlılıksız bir
 * `lib/` dosyasına) ayrıştırıldı. Sebep: `DanismanSatislariPanels.jsx`
 * `axios`, `ToastContext`, `components/ui/skeleton` (→ `@/lib/utils`) gibi
 * ağır bağımlılıklar içeriyor ve bu ortamda `@testing-library/react` kurulu
 * değil; bileşeni doğrudan import eden bir test dosyası jest'in `@/` alias'ını
 * çözemediği için (craco sadece webpack alias'ı tanımlıyor, jest
 * moduleNameMapper'ı yok) "Cannot find module '@/lib/utils'" ile patlıyor.
 * Bu dosyanın HİÇBİR import'u yok, o yüzden doğrudan test edilebilir
 * (bkz. `src/__tests__/crm/DanismanSatislariPanels.test.js`).
 */

/** S-15 Seçenek B: backend sıfır satır enjeksiyonunu koruyor (danışmanın
 * dönemde hiç satışı yoksa kendi satırını 0 değerli olarak yine döner —
 * bkz. backend/routes/ciro_dashboard.py "zero_row"). Burada bu satırı
 * "veri yok" / "hata" durumlarından görsel olarak ayırmak için tespit
 * ediyoruz: kendi satırı VE hem tutar hem adet gerçekten sıfır. Not: bu
 * satırda backend zaten toplam_tutar=0.0 (null DEĞİL) döner, o yüzden
 * fmtTutarOrDash'in "veri yok" (null/undefined → "—") davranışıyla
 * karışmaz.
 *
 * F-K1 düzeltmesi (2026-08): backend `_merge_yapilan_ciro`
 * (backend/routes/ciro_dashboard.py) tahsilatı olmayan ama YAPILAN CİROSU
 * olan danışman için de aynı şekli üretiyor (satis_adedi=0, toplam_tutar=0.0,
 * yapilan_ciro>0 — vadeli/borçlu satış, fatura kesildi ama henüz tahsil
 * edilmedi). Bu satır eskiden de "boş satır" sayılıp "Henüz satışınız yok"
 * ile eziliyordu — `yapilan_ciro` hiç gösterilmiyordu. Artık yalnızca HEM
 * tahsilat HEM yapılan ciro yokken (ya da `yapilan_ciro` backend'den henüz
 * gelmiyorsa — undefined "ciro var" SAYILMAZ, eski davranış korunur) satır
 * "boş" kabul edilir; `yapilan_ciro > 0` olan satır normal satır gibi
 * render edilip gerçek Yapılan Ciro değerini gösterir. */
export function isBosSatir(r) {
  const yapilanCiroVar = typeof r.yapilan_ciro === 'number' && r.yapilan_ciro > 0;
  return r.kendi === true && r.satis_adedi === 0 && r.toplam_tutar === 0 && !yapilanCiroVar;
}

/** F-K1: "satış var (yapılan ciro), tahsilat yok" durumunu "satış yok"tan
 * ayırt etmek için — Tahsil Edilen/Tahsilat hücresinde küçük bir ipucu
 * göstermek için kullanılır. Yeni kolon AÇMIYOR, mevcut hücreye ek etiket
 * ekliyor. `toplam_tutar` gerçekten 0 (maskeli "—" değil) VE `yapilan_ciro`
 * sayısal ve > 0 ise true döner. */
export function tahsilatBekliyorMu(r) {
  return typeof r.yapilan_ciro === 'number' && r.yapilan_ciro > 0 && r.toplam_tutar === 0;
}
